import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/routes/routes';
import { AuthHelper } from '@archistarai/auth-frontend';

// Setup Vue Router
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Auth Check
router.beforeEach(async (to, from, next) => {
  const result = await AuthHelper.RouterBeforeEach(to, from);
  if (result === false) {
    next(false);
  } else if (result && typeof result === 'object') {
    next(result);
  } else {
    next();
  }
});

export default router;
